<template>
  <div :class="['ba-loading', { absolute: absolutePosition, background: applyBackground }]">
    <i :class="`icon loading--${character}`"></i>
    <p v-if="showLoadingText"
       class="desc">
      <slot>{{ $t('common.' + loadingText) }}</slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'BaLoading',
  created () {
    this.character = this.characters[Math.floor(Math.random() * this.characters.length)]
  },
  props: {
    absolutePosition: {
      type: Boolean,
      default: true,
      required: false
    },
    showLoadingText: {
      type: Boolean,
      default: false,
      required: false
    },
    loadingText: {
      type: String,
      default: 'loadingDot',
      required: false
    },
    applyBackground: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      characters: ['loaf', 'dough'],
      character: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-loading {
  display: inline-block;
  z-index: 11;

  &.background {
    padding: 8px 10px 13px 10px;
    margin: auto;
    border-radius: 8px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: rgba(255, 255, 255, 0.8);
  }

  &.absolute {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .desc {
    margin-top: 3px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    text-align: center;
    color: #444444;
  }
}
</style>
